interface Props {
  page: number;
  totalPages: number;
  onPage: (page: number) => void;
}

export default function Pagination({ page, totalPages, onPage }: Props) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <nav aria-label="分页导航" className="flex items-center justify-center gap-1.5 mt-8">
      <button
        type="button"
        onClick={() => onPage(page - 1)}
        disabled={page === 1}
        className="h-9 px-3 rounded-md border hairline text-xs text-foreground-300 flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed hover:border-accent-500/50 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onPage(item)}
          aria-current={item === page ? "page" : undefined}
          className={`w-9 h-9 rounded-md text-xs font-label transition-colors cursor-pointer ${
            item === page
              ? "bg-accent-500 text-background-950 font-semibold"
              : "border hairline text-foreground-300 hover:border-accent-500/50 hover:text-accent-300"
          }`}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onPage(page + 1)}
        disabled={page === totalPages}
        className="h-9 px-3 rounded-md border hairline text-xs text-foreground-300 flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed hover:border-accent-500/50 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}